<button mat-flat-button color="primary" (click)="reload()">{{'try again' | translate}}</button>
